module.exports = __webpack_public_path__ + "media/icon/icon-truck-gray-e01d7987.svg";